module.exports = __webpack_public_path__ + "static/media/spectrum.14f7f0ee.svg";